import { toast } from 'react-toastify';
import styled from 'styled-components';
import { selectRoomParticipantInfo } from '@/store/features/room/selectors';
import { ParticipantSid } from '@/store/features/room/types';
import { selectUiSidebar } from '@/store/features/ui/selectors';
import { toggleUISidebar } from '@/store/features/ui/slice';
import { SideBarContent } from '@/store/features/ui/types';
import { store } from '../store';
import { playSound } from './sound';

const ChatToastWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.span`
  font-weight: bold;
  color: var(--color-text);
`;

const Message = styled.span`
  color: var(--color-text);
  font-size: var(--font-size-md);
  word-break: break-word;
`;

export const showChatToast = (sid: ParticipantSid, text: string) => {
  const state = store.getState();
  const sender = selectRoomParticipantInfo(sid)(state);
  const sidebar = selectUiSidebar(state);

  const isChatOpen = sidebar === SideBarContent.chat;

  if (!isChatOpen) {
    playSound('/media/new-message.wav');
    toast(
      <div>
        <ChatToastWrapper>
          <Title>{sender?.user?.name || 'Guest'}</Title>
          <Message>{text}</Message>
        </ChatToastWrapper>
      </div>,
      {
        icon: <span>💬</span>,
        closeOnClick: true,
        onClick() {
          store.dispatch(
            toggleUISidebar({
              sidebar: SideBarContent.chat,
              value: true,
            })
          );
        }
      }
    );
  }
};

export const showErrorToast = (title: string, message: string) => {
  toast(
    <div>
      <ChatToastWrapper>
        <Title>{title}</Title>
        <Message>{message}</Message>
      </ChatToastWrapper>
    </div>,
    {
      closeOnClick: true,
      type: 'error',
    }
  );
};